import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@tdwb/core';
import { WebbrokerCoreModule } from '@tdwb/webbroker/core';

import { OrderNotificationsToastComponent } from './toast/order-notifications-toast.component';

@NgModule({
  imports: [
    AngularCore,
    CoreModule,
    WebbrokerCoreModule,
    TranslateModule.forChild()
  ],
  declarations: [
    OrderNotificationsToastComponent
  ],
  exports: [
    OrderNotificationsToastComponent
  ]
})
export class OrderNotificationsToastModule {
}

export {
  OrderNotificationsToastComponent
};
